import { useSearchContext } from 'contexts/SearchContext';
import { useFiltersListContext } from '../contexts/FiltersListContext';
import { isValidFilter } from '../filters';

export const useListsByCompanies = () => {
	const { data } = useSearchContext();
	const { state: filters } = useFiltersListContext();

	if (data) {
		const lists = Object.values(data.reduce((acc, { company: { id, name, logo }, tags, ...list }) => {
			const tagIds = tags.map(({ id }) => id);
			if (isValidFilter(filters?.companies, id) && isValidFilter(filters?.tags, tagIds)) {
				const row = acc[id] ?? {id, name, logo, lists: []};
				acc[id] = {...row, lists: [...row.lists, {...list, tags }]};
			}
			return acc;
		}, {}));

		return lists.sort((a, b) => (a.name < b.name ? -1 : 1));
	}
	return data;
};